import Vue from "vue";
import GeneralPopup from "./GeneralPopup.vue";

let isExit = false;
let queue = [];
const defaultOptions = {
  title: "温馨提示",
  message: "测试",
  btns: [
    {
      text: "确认"
    }
  ],
  onClose: null,
  content: null,
  contentProps: {},
  custBody: false
};

const parseOptions = message => (isObj(message) ? message : { message });

function isObj(o) {
  const type = typeof o;
  return o !== null && (type === "object" || type === "function");
}

function createInstance(Comp) {
  let instance = null;
  if (!queue.length || !isExit) {
    const GeneralPopupVue = Vue.extend(GeneralPopup);
    instance = new GeneralPopupVue({
      el: document.createElement("div"),
      components: {
        Content: Comp
      }
    });
    document.body.appendChild(instance.$el);
    queue.push(instance);
  }
  return queue[queue.length - 1];
}

function GPopup(options = {}) {
  const gPopup = createInstance(options.content);
  options = {
    ...defaultOptions,
    ...parseOptions(options),
    clear() {
      if (!isExit) {
        queue = queue.filter(item => item !== gPopup);
        document.body.removeChild(gPopup.$el);
        gPopup.$destroy();
      }
    }
  };
  Object.assign(gPopup, options);
  return gPopup;
}

GPopup.clear = () => {
  if (queue.length) {
    queue.forEach(popup => {
      popup.clear();
    });
    queue = [];
  }
};

GPopup.install = Vue => {
  Vue.prototype.$popup = GPopup;
};

export default GPopup;
